import { Read } from '../helpers/cookies';
import { Config } from '../core/config';

export const isSuscriptor = () =>{
    var cookiePremium = Read("ProductoPremiumId").split(",");   
    return !!cookiePremium.find( x => x === Config.idCookiePremium );
} 

export const wallConBonificado = () => {
    return Config.hasBonificado;
}



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/services/wallService.js